import script from "./expertConsultant-operation.vue?vue&type=script&setup=true&lang=js"
export * from "./expertConsultant-operation.vue?vue&type=script&setup=true&lang=js"

import "./expertConsultant-operation.vue?vue&type=style&index=0&id=98270402&lang=scss&scoped=true"

import exportComponent from "/Users/wen/projects/chun-qiu-museum/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98270402"]])

export default __exports__